import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38eb26eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "star-circle-message" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "case-stock-content"
}
const _hoisted_4 = { class: "stock-name" }
const _hoisted_5 = {
  key: 0,
  class: "case-tag"
}
const _hoisted_6 = {
  key: 2,
  class: "message-text"
}
const _hoisted_7 = {
  key: 3,
  class: "message-text"
}
const _hoisted_8 = {
  key: 4,
  class: "message-text"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isTextMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "message-text",
          innerHTML: _ctx.renderTextMessage(_ctx.message.message)
        }, null, 8, _hoisted_2))
      : (_ctx.isCaseStock)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.caseStockInfo.stockName), 1),
            (_ctx.caseStockInfo.labelName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.caseStockInfo.labelName), 1))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.isImageMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "[图片]"))
          : (_ctx.isVoiceMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "[语音]"))
            : (_ctx.isLinkUrlMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.linkUrlInfo.url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openLink(_ctx.linkUrlInfo.url)), ["stop"]))
                      }, _toDisplayString(_ctx.linkUrlInfo.text), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.linkUrlInfo.text), 1))
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 5,
                  class: "message-text",
                  innerHTML: _ctx.renderTextMessage(_ctx.previewText)
                }, null, 8, _hoisted_10))
  ]))
}